/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Compagnie (PM de nature CIE) sélectionnable comme porteur de risque d'une garantie : assureur principal, co-assureur ou ré-assureur.
 * @export
 * @interface CompagnieMinimalDto
 */
export interface CompagnieMinimalDto {
    /**
     * Identifiant de la PersonneMorale, attendu par les commandes (assureurPersonneMoraleId et variantes co/ré).
     * @type {string}
     * @memberof CompagnieMinimalDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CompagnieMinimalDto
     */
    designation?: string | null;
    /**
     * Code sous-nature (MUT, REA…), null pour un assureur classique.
     * @type {string}
     * @memberof CompagnieMinimalDto
     */
    sousNature?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompagnieMinimalDto
     */
    sousNatureLibelle?: string | null;
}

/**
 * Check if a given object implements the CompagnieMinimalDto interface.
 */
export function instanceOfCompagnieMinimalDto(value: object): value is CompagnieMinimalDto {
    return true;
}

export function CompagnieMinimalDtoFromJSON(json: any): CompagnieMinimalDto {
    return CompagnieMinimalDtoFromJSONTyped(json, false);
}

export function CompagnieMinimalDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompagnieMinimalDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'designation': json['designation'] == null ? undefined : json['designation'],
        'sousNature': json['sousNature'] == null ? undefined : json['sousNature'],
        'sousNatureLibelle': json['sousNatureLibelle'] == null ? undefined : json['sousNatureLibelle'],
    };
}

export function CompagnieMinimalDtoToJSON(json: any): CompagnieMinimalDto {
    return CompagnieMinimalDtoToJSONTyped(json, false);
}

export function CompagnieMinimalDtoToJSONTyped(value?: CompagnieMinimalDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'designation': value['designation'],
        'sousNature': value['sousNature'],
        'sousNatureLibelle': value['sousNatureLibelle'],
    };
}

